<template>
  <div class="product-filter-group mb-1">
    <button
      aria-controls="filter-group--capacity"
      aria-expanded="true"
      class="product-filter-group__button"
      data-target="#filter-group--capacity"
      data-toggle="collapse"
      role="button"
    >
      {{ labels.label }}
    </button>
    <div id="filter-group--capacity" class="collapse show py-1">
      <ul class="nav align-items-center ml-1 form-group--unit">
        <li class="form-group__label"><label>{{ labels.unit }}</label></li>
        <li
          v-for="option in options"
          :key="option.key"
          class="form-group__input"
        >
          <input
            type="radio"
            name="unit"
            :value="option.value"
            :id="'unit--' + option.value"
            v-model="unit"
            class="d-none"
          />
          <label :for="'unit--' + option.value">{{ option.label }}</label>
        </li>
      </ul>
      <ul class="nav align-items-sm-center ml-1 form-group--capacity">
        <li class="form-group__label">
          <label for="input--capacity">{{ labels.label }}</label>
        </li>
        <li class="d-sm-flex d-md-block form-group__input">
          <div class="input-wrapper mb-1">
            <label for="input--capacityMin" class="sr-only">{{ labels.min_cap }}</label>
            <input
              type="number"
              v-model.number="capacityMin"
              id="input--capacityMin"
            />
            <span>{{ labels.range_keyword }}</span>
            <label for="input--capacity" class="sr-only">{{ labels.max_cap }}</label>
            <input
              type="number"
              :min="capacityMin"
              v-model.number="capacity"
              id="input--capacity"
            />
            {{ labels.units[unit] }}
          </div>
          <button
            :disabled="disabled"
            @click="add"
            class="btn--orange-o"
          >
            {{ labels.submit }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
const Units = {
  ML: "ml",
  OZ: "floz",
};
import { FilterType } from "../@types/Filters"
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      unit: Units.ML,
      defaultUnit: Units.ML,
      cachedCapacity: 0,
      cachedCapacityMin: 0,
      capacity: 0,
      capacityMin: 0,
      metaCapacity: 0,
      metaCapacityMin: 0,
      // options: [
      //   {
      //     key: Units.ML,
      //     value: "ml",
      //   },
      //   {
      //     key: Units.OZ,
      //     value: "oz",
      //   },
      // ],
    };
  },
  methods: {
    ...mapActions(['addFilter']),
    convertUnit(capacity, to) {
      if (to === Units.ML) {
        return +(capacity * 29.5735).toFixed(2);
        // return +(capacity * 30).toFixed(2);
      } else {
        return +(capacity / 29.5735).toFixed(2);
        // return +(capacity / 30).toFixed(2);
      }
    },
    add() {
      this.addFilter({
          type: FilterType.Meta,
          handle: "capacity",
          name:
            this.capacityMin > 0
              ? `${this.capacityMin}-${this.capacity}${this.unit}`
              : `${this.capacity}${this.unit}`,
          value: {
            min: this.metaCapacityMin,
            max: this.metaCapacity + 15,
          }
        })
        .then(() => {
          this.cachedCapacity = this.capacity;
          this.cachedCapacityMin = this.capacityMin;
        });
    },
  },
  computed: {
    options() {
      return [
        {
          key: Units.ML,
          value: "ml",
          label: this.labels.units.ml
        },
        {
          key: Units.OZ,
          value: "oz",
          label: this.labels.units.oz
        },
      ]
    },
    labels() {
      return TG.vue.labels.capacity_slider
    },
    disabled() {
      return (
        this.capacity === this.cachedCapacity &&
        this.capacityMin === this.cachedCapacityMin
      );
    },
  },
  watch: {
    capacity() {
      if (this.unit !== Units.ML) {
        this.metaCapacity = this.convertUnit(this.capacity, Units.ML);
      } else {
        this.metaCapacity = this.capacity;
      }
    },
    capacityMin() {
      if (this.unit !== Units.ML) {
        this.metaCapacityMin = this.convertUnit(this.capacityMin, Units.ML);
      } else {
        this.metaCapacityMin = this.capacityMin;
      }
    },
    unit(val, oldVal) {
      this.capacity = this.convertUnit(this.capacity, val);
      this.capacityMin = this.convertUnit(this.capacityMin, val);
    },
  },
};
</script>
<style lang="scss">
@import "../../../scss/theme/variables.scss";
.form-group {
  &--capacity {
    .form-group {
      &__input {
        max-width: 100%;
        .input-wrapper {
          margin-right: 0.5rem;
          line-height: 1;
          flex: 1 1 100%;
          display: flex;
          max-width: 100%;
        }
        input {
          text-align: center;
          line-height: 1;
          flex: 1 1 auto;
          max-width: 40%;
        }
      }
      &__label {
        margin-right: 0.5rem;
      }
    }
  }
  &--unit {
    .form-group {
      &__input {
        margin-right: 1rem;

        input + label {
          &::before {
            margin-right: 0.5rem !important;
            border-color: $color-black-75;
          }
          &:hover {
            cursor: pointer;
          }
        }
        input:checked + label {
          &::before {
            border-color: $color-orange;
            box-shadow: inset 0px 0px 0px 4px $color-orange;
          }
        }
      }
      &__label {
        margin-right: 1rem;
      }
    }
  }
}
</style>
